<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-md-6" v-show="tieneAlias('Panel de cliente')">
        <label for="" class="form-label">Número de cliente</label>
        <div class="input-group">
          <span class="form-control">
            {{ localCliente.prefnumcli || "pref" }}-{{localCliente.numero || "001"}}
          </span>
          <button
            class="btn btn-light"
            title="Copiar clave del cliente"
            @click="copiarNumeroCliente()"
          >
            <i class="mdi mdi-content-copy"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-6 col-md-6" v-show="tieneAlias('Panel de cliente')">
        <label for="" class="form-label">Clave de acceso</label>
        <div class="input-group">
          <input
            class="form-control"
            name="clave"
            :placeholder="mostrar_clave ? 'Password' : '******'"
            :type="mostrar_clave ? 'text' : 'password'"
            v-model="localCliente.clave_sin_encriptar"
            @input="actualizarCliente()"
          />
          <button
            class="btn btn-light"
            @click="mostrar_clave = !mostrar_clave"
            :title="!mostrar_clave ? 'Mostrar clave del cliente' : 'Ocultar clave del cliente'"
          >
            <i
              class="mdi"
              :class="{
                'mdi-eye': !mostrar_clave,
                'mdi-eye-off': mostrar_clave
              }"
            ></i>
          </button>
          <button 
            class="btn btn-light"
            title="Generar una nueva clave para el cliente"
            @click="generarClave()"
          >
            <i class="mdi mdi-cog-clockwise"></i>
          </button>
          <button
            class="btn btn-light"
            title="Copiar clave del cliente"
            @click="copiarClave()"
          >
            <i class="mdi mdi-content-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CmpPanel',
  props: ["cliente", "tieneAlias", "cargarAliasCampo"],
  data() {
    return {
      localCliente: {},
      mostrar_clave: false,
    }
  },
  watch: {
    cliente: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localCliente = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    actualizarCliente: function() {
      var self = this
      self.$emit("update:cliente", JSON.parse(JSON.stringify(this.localCliente)))
    },

    copiarNumeroCliente: function() {
      var self = this,
      valor = self.localCliente.prefnumcli+"-"+self.localCliente.numero

      var aux = document.createElement("input");
      aux.setAttribute("value", valor);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      iu.msg.success("El numero de cliente <strong>"+valor+"</strong>, se a copiado correctamente", { width: 400 })
    },

    generarClave: function() {
      var self = this, password = '',
          chars = "abcdefghijklmnopqrstubwsyz1234567890@-+<>()=[]{}"

      for(let i=0; i< 9; i++){
        password+=chars.charAt(Math.floor(Math.random()*chars.length));
      }

      self.localCliente.clave_sin_encriptar = password

      let nombre_cliente = self.localCliente.nombre +
        (self.localCliente.apellido_paterno ? ' '+self.localCliente.apellido_paterno : '') +
        (self.localCliente.apellido_materno ? ' '+self.localCliente.apellido_materno : ''),
        mensaje = "Se ha generado correctamente una nueva clave de acceso para el cliente "+nombre_cliente

      if(self.modo != "nuevo") mensaje += ". <br><br> Es necesario actualizar el cliente para poder almacenar la nueva clave de acceso."
      iu.msg.question(mensaje, { width: 500 })

      self.actualizarCliente()
    },

    copiarClave: function() {
      var self = this

      var aux = document.createElement("input");
      aux.setAttribute("value", self.localCliente.clave_sin_encriptar);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      let nombre_cliente = self.localCliente.nombre +
        (self.localCliente.apellido_paterno ? ' '+self.localCliente.apellido_paterno : '') +
        (self.localCliente.apellido_materno ? ' '+self.localCliente.apellido_materno : '')

      iu.msg.success("La clave del cliente "+nombre_cliente+", se a copiado correctamente")
    },
  }
}
</script>

<style scoped>
</style>